const _apiBase = 'https://course-project-itransitions.herokuapp.com/api'; 

export {_apiBase}